import { Row } from 'app/design/primitives/box';
import { Text } from 'app/design/primitives/text';
import { useTranslation } from 'react-i18next';
export function LoanFeeTag({ loanFee }: { loanFee?: number | null }) {
  const { t } = useTranslation('all-listings');

  return loanFee ? (
    <Row
      alignItems="center"
      alignSelf="flex-start"
      backgroundColor="surface.inverse.tertiary-neutral"
      borderRadius="radius.lg"
      gap="spacing.general.x2"
      paddingHorizontal="spacing.general.x2"
      paddingVertical="spacing.general.x1"
    >
      <Text fontSize={12} variant="bodyBase">
        {t('x$', { ns: 'common', amount: loanFee.toFixed(loanFee % 1 === 0 ? 0 : 2) })}
      </Text>
      <Text fontSize={12} variant="bodyBase">
        {t('listingCard.loanFee', { ns: 'loanFee' })}
      </Text>
    </Row>
  ) : null;
}
